import "@sidelinesports/fan-design-system/global.css";
import "@sidelinesports/fan-design-system/background.css";
import "@sidelinesports/fan-design-system/index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root container not found");
}

const root = createRoot(container);

async function main() {
  // In production be-fan inlines the theme in the document. In development
  // the vite server serves the template unchanged, so fill it here, before
  // the first render.
  if (import.meta.env.DEV) {
    try {
      const { loadThemeInDev } = await import("./load-theme-in-dev.ts");
      await loadThemeInDev();
    } catch (error) {
      // Report the failure, then render anyway. An unbranded app beats a
      // blank page, and only development reaches this path.
      console.error("Failed to load the theme in development", error);
    }
  }

  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

main().catch((error) => {
  console.error("Failed to start the app", error);
});
